'use strict';

function updatePhonePrefixSelectOnInit() {
  var phonePrefixElement = $('form #registration-form-phone-prefix, form #phone-prefix');
  if(phonePrefixElement.length) {
    var $selectElement = phonePrefixElement;
    var selectedOption = $selectElement.find('option:selected');
    if (selectedOption.length) {
      //$selectElement.attr('data-country', country);
      var country = selectedOption.data('country');
      var $flagElement = $('.country-flag');
      $flagElement.attr('data-country', country);
    }
  }
}
function attachPhonePrefixSelectEventOnChange() {
  $('form #registration-form-phone-prefix, form #phone-prefix, form .country-flag').on('change', function(e){
    var $currentElement = $(e.currentTarget);
    if ($currentElement.length) {
      var $selectedOptionElement = $currentElement.find('option:selected');
      if ($selectedOptionElement.length) {
        // $currentElement.attr('data-country', $selectedOptionElement.data('country'));
        var $flagElement = $('.country-flag');
        $flagElement.attr('data-country', $selectedOptionElement.data('country'));
      }
    }
  });
}

module.exports = {
  init: function() {
    updatePhonePrefixSelectOnInit();
    attachPhonePrefixSelectEventOnChange();
  }
}